
import {RequestServerClass} from '@/util/request';
import MapConfig from './model/MapConfig';
import SymbolConfig from './model/SymbolConfig';

export class MapService {

    public rSerivce: any;

    constructor(opt: any, axiosFilterFn?: any) {
        this.rSerivce = new RequestServerClass(opt);
    }
    /**
     * 获取地图配置
     */
    public getMapConfig(configUrl: string = './json/map.json') {
        return new Promise(async (resolve, reject) => {
            const res: any = await this.rSerivce.serverObj.get(configUrl);
            const mapConfig: MapConfig = new MapConfig();
            mapConfig.Map = res.data.map;
            mapConfig.BaseLayers = res.data.baseLayers;
            mapConfig.SwitchLayers = res.data.switchLayers;
            mapConfig.Map3D = res.data.map3d;
            mapConfig.BaseLayer3d = res.data.baseLayer3d;
            resolve(mapConfig);
        });
    }

    /**
     * 获取符号配置
     */
    public getSymbolConfig(configUrl: string = './json/symbol.json') {
        return new Promise(async (resolve, reject) => {
            const res: any = await this.rSerivce.serverObj.get(configUrl);
            const symbolConfig: SymbolConfig = new SymbolConfig();
            symbolConfig.Icons = res.data.icons;
            symbolConfig.Symbols = res.data.symbols;
            resolve(symbolConfig);
        });
    }

}
